import styled, { css } from "styled-components";

const getColors = (campaign) =>
  campaign &&
  campaign.template &&
  campaign.template.appearence &&
  campaign.template.appearence.colors;

const ClassBuilder = styled.div.withConfig({
  // Prevent the `campaign` object from being forwarded to the underlying <div>.
  // Without this filter React warns: "Received object for non-boolean attribute
  // 'campaign'" — the root cause of the "Campaign Props: Object" console error.
  shouldForwardProp: (prop) => prop !== 'campaign',
})`
  ${(props) => {
    const colors = getColors(props.campaign);
    const brandDefault = colors && colors["brand-default"];
    const brandHover = colors && colors["brand-hover"];
    const brandPressed = colors && colors["brand-pressed"];
    const brandLight = colors && colors["brand-light"];
    const textTertiary = colors && colors["text-tertiary"];
    const backgroundPage = colors && colors["background-page"];

    return (
      props.campaign &&
      css`
    font-style: inherit;
    .primary-text {
      color: ${brandDefault}
    }
    .text-color {
      color: ${brandPressed}
    }

    .secondary-text {
      color: ${brandHover}
    }
    .header-text {
      color: ${textTertiary}
    }
    .navbar-text {
      color: ${textTertiary}
    }
    .table-body-color { color: #8E959B; }

    .dropdown-item { color: #000000; }

    .table-body-color-bg {
      background: #dae1e7;
      fill: #dae1e7;
    }

    .navbar-text-white {
      color: white
    }

    .primary-bg {
      background: ${brandDefault};
      fill: ${brandDefault};
    }

    .primary-fill {
      fill: ${brandDefault}
    }
    .secondary-fill {
      fill: ${brandHover}
    }
    .navbar-fill {
      fill: ${textTertiary}
    }
    .mish-fill {
      fill: ${textTertiary}
    }

    .primary-bg-after {
      &:after {
        background: ${brandDefault}
      }
    }

    .secondary-bg {
      background: ${brandHover};
      fill: ${brandHover};
    }

    .text-bg {
      background: ${brandPressed};
      fill: ${brandPressed};
    }

    .header-bg {
      background: ${backgroundPage}
    }

    .navbar-bg {
      background: ${textTertiary}
    }

    .footer{
      background: ${backgroundPage};
      color: ${textTertiary}
    }

    .mish-bg {
      background: ${textTertiary};
      fill: ${textTertiary};
    }

    .border-mish {
      border-color: ${textTertiary}
    }

    .border-primary {
      border-color: ${brandDefault}
    }
    .border-secondary {
      border-color: ${brandHover}
    }
    .border-navbar {
      border-color: ${textTertiary}
    }

    .primary-border-color{
      border-color: ${brandDefault}
    }

    .half-gradient {
      background: linear-gradient(to bottom, ${brandDefault} 20%, #973031 50%, white 50%)
    }
    .navbar-campaign-link {
      position:relative;
      color: ${textTertiary};
      &:after {
        transition: background-color 300ms ease-in;
        content: '';
        position:absolute;
        bottom:0;
        left:0;
        width: 100%;
        height: 2px;
        background: transparent;
      }
      &:visited {
        color: ${textTertiary};
      }
      &:hover {
        color: ${brandDefault};
        &:after {
          background: ${brandDefault};
        }
        path, circle, rect, line {
          stroke: ${brandDefault};
        }
      }
    }
    .campaign-link {
      position:relative;
      color: ${textTertiary};
      &:after {
        transition: background-color 300ms ease-in;
        content: '';
        position:absolute;
        bottom:0;
        left:0;
        width: 100%;
        height: 2px;
        background: transparent;
      }
      &:visited {
        color: ${textTertiary};
      }
      &:hover {
        color: ${brandDefault};
        &:after {
          background: ${brandDefault};
        }
        path, circle, rect {
          stroke: ${brandDefault};
        }
      }
    }
    .navbar-active-link {
    
      position:relative;
      color: ${brandDefault}
      &:visited {
        color: ${brandDefault};
      }
      &:hover {
        color: ${brandDefault};
      }
      &:after {
        content: '';
        position:absolute;
        bottom:0;
        left:0;
        width: 100%;
        height: 4px;
        background: ${brandDefault}
      }
    }

    .campaign-link-sub-navbar {
      position:relative;
      color: ${brandDefault};
      &:after {
        transition: background-color 300ms ease-in;
        content: '';
        position:absolute;
        bottom:0;
        left:0;
        width: 100%;
        height: 2px;
        background: transparent;
      }
      &:visited {
        color: ${brandHover};
      }
      &:hover {
        color: ${brandDefault};
        &:after {
          background: ${brandDefault};
        }
        path, circle, rect {
          stroke: ${brandHover};
        }
      }
    }

    .svg-primary-fill {
      path, circle, rect {
        fill: ${brandDefault};
      }
    }
    .navbar-campaign-link-icon {
      color: ${textTertiary};
      background-color: ${backgroundPage};
      .navbar-campaign-link-icon__stroke {
        path, circle, rect {
          stroke: ${textTertiary};
        }
      }
      &:hover {
        span#notification-counter{
          color: ${brandDefault};
          background-color: ${brandHover};
        }
        color: ${brandDefault};
        background-color: ${brandHover};
        .navbar-campaign-link-icon__stroke {
          path, circle, rect {
            stroke: ${brandDefault};
            fill: ${brandDefault};
          }
        }

      }
    }
    .campaign-link-icon {
         path, circle, rect, polyline, line {
          stroke: ${textTertiary};
        }
      &:hover {
        path, circle, rect, polyline, line {
          stroke: ${brandDefault};
        }
      }
    }
    .campaign-drop-down-item {
      &:hover {
        & > path, & >  circle, & > rect, & > polyline, & > line {
          stroke: ${brandDefault};
        }
        color: ${brandDefault};
      }
    }
    .active-link {
      position:relative;
      &:visited {
        color: ${brandDefault};
      }
      &:hover {
        color: ${brandDefault};
      }
      &:after {
        content: '';
        position:absolute;
        bottom:0;
        left:0;
        width: 100%;
        height: 2px;
        background: ${brandDefault}
      }
    }



    &__menu, __menu-list {
      border-radius: 0px;
      width: calc(100% - 1rem)
    }

    &__control {
      border-color: #8E959B;
      box-shadow: none;
      border-radius: 0px;
      &--is-focused, &--menu-is-open {
        border: 1px solid ${textTertiary};
        &:hover {
          border: 1px solid ${textTertiary};
        }
      }
    }

    &__option {
      width: calc(100% - 10px);
      margin: 0 5px;
      color: #8E959B;
      cursor: pointer;
      background: white;

      &--is-focused  {
        color: ${textTertiary};
        background: #FAFAFA;
      }

      &--is-selected {
        color: ${textTertiary};
        background: #FAFAFA;
      }

      &:active {
        background: ${textTertiary};
        background: ${brandPressed};

      }
    }
  }
  
    .campaign-link-icon-reverse {
      color: ${backgroundPage};
      background-color: ${textTertiary};
      border: 1px solid ${backgroundPage};
      &:hover {
        color: ${textTertiary};
        background-color: ${backgroundPage};
        path, circle, rect {
          stroke: ${backgroundPage};
        }
      }
    }

    .navbar-campaign-link-icon-reverse {
      color: ${backgroundPage};
      background-color: ${textTertiary};
      border: 1px solid ${backgroundPage};
      &:hover {
        color: ${backgroundPage};
        background-color: ${textTertiary};
        path, circle, rect {
          stroke: ${backgroundPage};
        }
      }
    }
    .drop-down-item {
      &:hover {
        path, circle, rect, polyline,line {
          stroke:#000000;
        }
        color: #000000;
      }
    }
    .campaign-drop-down-item {
      &:hover {
        path, circle, rect, polyline,line {
          stroke: ${brandDefault};
        }
        color: ${brandDefault};
      }
    }

    .active-link {
      position:relative;
      &:visited {
        color: ${brandDefault};
      }
      &:hover {
        color: ${brandDefault};
      }
      &:after {
        content: '';
        position:absolute;
        bottom:0;
        left:0;
        width: 100%;
        height: 2px;
        background: ${brandDefault}
      }
    }

    .active-link-sub-navbar {
      position:relative;
      &:visited {
        color: ${brandDefault};
      }
      &:hover {
        color: ${brandDefault};
      }
      &:after {
        content: '';
        position:absolute;
        bottom:0;
        left:0;
        width: 100%;
        height: 2px;
        background: ${brandDefault}
      }
    }

    .gl-dots{
      color: gray;
      .slick-active {
        span {
          color : ${brandDefault};
        }
      }
    }
    .level-active{
      g{
        g{
          use{
            fill: ${brandDefault}
          }
        }
      }
    }
    .level-next-level{
      g{
        g{
          use{
            fill: ${brandHover}
          }
        }
      }
    }
    .level-locked{
      g{
        g{
          use{
            fill:gray
          }
        }
      }
    }
      
    .gl-rankings {
      &__data {
        @extend %dead-grey;
        border-top: 11px solid #ffffff;

        &-separator {
          border-color: ${brandDefault};
          border-width: 1px;
          width: 100%;

          &.red {
            border-color: #ff6752;
          }
        }
      }
    }




  `
    );
  }}
`;
export default ClassBuilder;
